function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#757575",
  d: "M14.88,22c-0.11,0-0.22,0-0.33-0.01c-0.021,0-0.05,0-0.07-0.01C14.609,21.99,14.74,22,14.88,22z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#757575",
  d: "M14.88,21c-0.12,0-0.25,0-0.37-0.01c-0.03,0-0.06-0.01-0.09-0.01c-0.09-0.012-0.17-0.021-0.26-0.03 c0.12,0.01,0.24,0.021,0.359,0.03C14.641,20.99,14.76,21,14.88,21z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#757575",
  d: "M14.641,7.03c-0.041,0-0.08-0.01-0.121-0.01C14.35,7.01,14.18,7,14,7c0.16,0,0.32,0.01,0.47,0.03 c0.11,0,0.209,0.01,0.32,0.02C14.74,7.04,14.689,7.03,14.641,7.03z M14.83,7.05h-0.04c0.19,0.02,0.37,0.05,0.55,0.08 C15.17,7.1,15,7.07,14.83,7.05z M13.6,20.98c0.02,0.01,0.05,0.01,0.07,0.01C13.78,21,13.89,21,14,21 C13.86,21,13.73,20.99,13.6,20.98z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#757575",
  d: "M14.16,20.95c0.09,0.01,0.17,0.021,0.26,0.03h0.1C14.4,20.971,14.28,20.96,14.16,20.95z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#757575",
  d: "M19.279,8.21L17.95,9.49C19.21,10.59,20,12.2,20,14c0,3.07-2.32,5.6-5.279,5.95 C14.48,19.971,14.24,20,14,20c-0.12,0-0.25,0-0.37-0.01s-0.23-0.03-0.35-0.04c-1.58-0.19-2.98-0.99-3.93-2.171l-0.72,0.691 L8.5,18.6l-0.76,0.73c1.64,0.84,3.48,1.479,5.45,1.62c0,0,0,0,0.01,0c0.05,0.01,0.1,0.021,0.15,0.01c0.02,0,0.05,0.011,0.07,0.011 c0.06,0.01,0.12,0.01,0.18,0.01C13.73,20.99,13.86,21,14,21s0.28,0,0.42-0.02c-0.09-0.012-0.17-0.021-0.26-0.03 c0.12,0.01,0.24,0.021,0.359,0.03c0.041,0,0.08-0.012,0.121-0.012c0.069,0,0.129-0.01,0.189-0.02C21.609,20.439,27,14,27,14 S23.82,10.21,19.279,8.21z M19.09,18.8C20.279,17.54,21,15.859,21,14c0-1.86-0.721-3.54-1.91-4.8c3.08,1.41,5.49,3.69,6.551,4.8 C24.58,15.109,22.17,17.391,19.09,18.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#757575",
  d: "M14.79,7.05c-0.11-0.01-0.21-0.02-0.32-0.02c0.02-0.01,0.03-0.01,0.049-0.01c0.041,0,0.08,0.01,0.121,0.01 C14.689,7.03,14.74,7.04,14.79,7.05z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#757575",
  d: "M15.34,7.13c-0.18-0.03-0.359-0.06-0.55-0.08h0.04C15,7.07,15.17,7.1,15.34,7.13z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#757575",
  d: "M14.37,8.01C14.25,8.01,14.12,8,14,8c0.24,0,0.48,0.03,0.721,0.05C14.6,8.04,14.49,8.02,14.37,8.01z  M13.6,20.98c0.02,0.01,0.05,0.01,0.07,0.01C13.78,21,13.89,21,14,21C13.86,21,13.73,20.99,13.6,20.98z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#757575",
  d: "M22.21,3.71l-4.17,4.02c-1.021-0.35-2.101-0.6-3.21-0.68C15,7.07,15.17,7.1,15.34,7.13 c-0.18-0.03-0.359-0.06-0.55-0.08c-0.11-0.01-0.21-0.02-0.32-0.02C14.32,7.01,14.16,7,14,7c-0.27,0-0.54,0.02-0.8,0.05 C6.4,7.53,1,14,1,14s2.24,2.68,5.65,4.721l-3.44,3.309l0.16,0.15l0.54,0.529l3.62-3.49l0.75-0.729l0.2-0.19l0.72-0.69l2.23-2.159 l4.179-4.02l2.16-2.09l1.289-1.23l3.852-3.72L22.21,3.71z M7.39,18c-2.35-1.35-4.16-3.08-5.04-4c1.06-1.11,3.48-3.4,6.57-4.8 C7.72,10.46,7,12.14,7,14c0,1.27,0.33,2.45,0.94,3.471L7.39,18z M14.6,11.05C14.43,11.02,14.24,11,14.06,11c-1.66,0-3,1.34-3,3 c0,0.15,0.01,0.29,0.04,0.43l-2.42,2.33C8.24,15.93,8,15,8,14c0-3.07,2.31-5.6,5.28-5.95C13.52,8.03,13.76,8,14,8 c0.12,0,0.25,0.01,0.37,0.01c0.12,0.01,0.229,0.03,0.351,0.04c0.799,0.09,1.559,0.35,2.229,0.73L14.6,11.05z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#757575",
  d: "M17.061,14c0,1.66-1.351,3-3,3c-1.05,0-1.97-0.54-2.51-1.35l4.25-4.09C16.561,12.1,17.061,12.99,17.061,14z "
}));

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  fill: "#FFFFFF",
  points: "3.37,22.18 3.91,22.71 3.36,22.189  "
}));

var SvgClosedEye = function SvgClosedEye(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    enableBackground: "new 0 0 28 28",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClosedEye, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/closed_eye.f592f49e.svg";
export { ForwardRef as ReactComponent };